var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "result-view-content" },
    [
      _vm.isLoadingHistory
        ? _c("LoadingSpinner", {
            attrs: {
              text: "データを読み込み中...",
              size: "medium",
              variant: "inline",
            },
          })
        : [
            _c("ChatMessage", {
              staticClass: "result-view-content__message",
              attrs: {
                message: _vm.headerMessage,
                "cat-icon-size": "medium",
                "writer-type": _vm.historyWriterType,
              },
            }),
            _c("div", { staticClass: "result-view-content__feedback" }, [
              _c(
                "div",
                { staticClass: "result-view-content__feedback-content" },
                [
                  _c(
                    "div",
                    {
                      ref: "feedbackHtmlRoot",
                      staticClass: "result-view-content__feedback-text",
                      class: {
                        "result-view-content__feedback-text--html":
                          _vm.isHtmlFeedback,
                      },
                    },
                    [
                      _vm.isHtmlFeedback
                        ? _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$sanitize(_vm.displayFeedbackText)
                              ),
                            },
                          })
                        : _c("div", [_vm._v(_vm._s(_vm.displayFeedbackText))]),
                    ]
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "result-view-content__actions" }, [
              _vm.canApplyThemeGenerate
                ? _c(
                    "button",
                    {
                      staticClass: "result-view-content__apply-button",
                      attrs: {
                        type: "button",
                        disabled: _vm.isApplyingThemeGenerate,
                      },
                      on: { click: _vm.handleApplyThemeGenerate },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isApplyingThemeGenerate
                              ? _vm.$t("themeGenerate.apply.applying")
                              : _vm.$t("themeGenerate.apply.button")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "result-view-content__back-button",
                  on: { click: _vm.handleBackClick },
                },
                [_vm._v("一覧にもどる")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "result-view-content__notice" },
              [
                _c("p", { staticClass: "result-view-content__notice-text" }, [
                  _vm._v("※ メニュー「過去ログ」から再度閲覧できます"),
                ]),
                _vm.isMatchingThemeResult
                  ? [
                      _c(
                        "p",
                        { staticClass: "result-view-content__notice-text" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "themeMatching.result.disclaimerRecruitment"
                              )
                            )
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _vm.isGenerateThemeResult
                  ? [
                      _c(
                        "p",
                        { staticClass: "result-view-content__notice-text" },
                        [_vm._v(_vm._s(_vm.$t("themeGenerate.apply.notice")))]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }